var ID_CONNECTOR, buildNmaData, buildNmaPrintoutTableData, gdtDataToNmaData, getColorCodes, getDefaultVizConfig, getNmaQuestionOutcomes, getRowId, mediator, nmaDataToVizData, normalizeTableOrder, _ref;

_ref = require('lib/nma_helper'), gdtDataToNmaData = _ref.gdtDataToNmaData, nmaDataToVizData = _ref.nmaDataToVizData, getColorCodes = _ref.getColorCodes;

mediator = require('mediator');

ID_CONNECTOR = '#';

getRowId = function(rowData) {
  var _ref1, _ref2;
  return _.compact([(_ref1 = rowData.rowElement) != null ? _ref1.id : void 0, (_ref2 = rowData.comparator) != null ? _ref2.id : void 0]).join(ID_CONNECTOR);
};

getNmaQuestionOutcomes = function(question, outcomesById) {
  if (question == null) {
    return Immutable.List();
  }
  return question.get('outcomes', Immutable.List()).map(function(outcomeId) {
    return outcomesById.get(outcomeId);
  }).filter(function(outcome) {
    return outcome != null;
  }).toList();
};

buildNmaData = function(question, outcomesById) {
  var outcomes;
  outcomes = getNmaQuestionOutcomes(question, outcomesById);
  if ((question != null ? typeof question.isEmpty === "function" ? question.isEmpty() : void 0 : void 0) || outcomes.isEmpty()) {
    return;
  }
  return gdtDataToNmaData(question, outcomes);
};

getDefaultVizConfig = function(question, nmaData, config) {
  var comparatorId, firstInterventionId, interventions, outcomes, questionVizConfig, selectedInterventionIds, selectedOutcomeIds, _base, _ref1, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9;
  if (config == null) {
    config = {};
  }
  questionVizConfig = (question != null ? question.get : void 0) != null ? (_ref1 = typeof (_base = question.get('vizConfig', Immutable.Map())).toJS === "function" ? _base.toJS() : void 0) != null ? _ref1 : {} : {};
  config = _.extend({}, questionVizConfig, config);
  interventions = (_ref2 = nmaData.interventions) != null ? _ref2 : [];
  outcomes = (_ref3 = nmaData.outcomes) != null ? _ref3 : [];
  firstInterventionId = (_ref4 = interventions[0]) != null ? _ref4.id : void 0;
  comparatorId = (_ref5 = (_ref6 = config.comparatorId) != null ? _ref6 : question != null ? typeof question.get === "function" ? question.get('commonComparator') : void 0 : void 0) != null ? _ref5 : firstInterventionId;
  selectedInterventionIds = (_ref7 = config.selectedInterventionIds) != null ? _ref7 : _.chain(interventions).pluck('id').without(comparatorId).value();
  selectedOutcomeIds = (_ref8 = config.selectedOutcomeIds) != null ? _ref8 : _.pluck(outcomes, 'id');
  return _.extend({}, config, {
    colorCodes: (_ref9 = config.colorCodes) != null ? _ref9 : getColorCodes(),
    comparatorId: comparatorId,
    comparatorTableMode: (_ref10 = config.comparatorTableMode) != null ? _ref10 : 'CommonComparator',
    denominator: (_ref11 = config.denominator) != null ? _ref11 : NmaComponents.STANDARD_DENOMINATOR,
    interventionComparisonPairs: (_ref12 = config.interventionComparisonPairs) != null ? _ref12 : [],
    selectedInterventionIds: selectedInterventionIds,
    selectedOutcomeIds: selectedOutcomeIds,
    showHighlights: (_ref13 = config.showHighlights) != null ? _ref13 : true,
    showThresholds: (_ref14 = config.showThresholds) != null ? _ref14 : true,
    tableOrder: (_ref15 = config.tableOrder) != null ? _ref15 : {},
    thresholdType: nmaData.thresholdType
  });
};

normalizeTableOrder = function(tableOrder, data, outcomes) {
  var columnOrder, interventionRowsOrder, outcomeRowsOrder, _ref1, _ref2, _ref3;
  if (tableOrder == null) {
    tableOrder = {};
  }
  interventionRowsOrder = (_ref1 = tableOrder.interventionRowsOrder) != null ? _ref1 : data.map(getRowId);
  outcomeRowsOrder = (_ref2 = tableOrder.outcomeRowsOrder) != null ? _ref2 : outcomes.map(function(outcome) {
    return outcome.id;
  });
  columnOrder = (_ref3 = tableOrder.columnOrder) != null ? _ref3 : outcomes.map(function(outcome) {
    return outcome.id;
  });
  return {
    interventionRowsOrder: interventionRowsOrder,
    outcomeRowsOrder: outcomeRowsOrder,
    columnOrder: columnOrder
  };
};

buildNmaPrintoutTableData = function(question, outcomesById, vizConfig) {
  var config, data, nmaData, outcomes, selectedInterventions, tableOrder;
  if (vizConfig == null) {
    vizConfig = {};
  }
  nmaData = buildNmaData(question, outcomesById);
  if (!nmaData) {
    return;
  }
  config = getDefaultVizConfig(question, nmaData, vizConfig);
  selectedInterventions = nmaData.interventions.filter(function(intervention) {
    return config.selectedInterventionIds.includes(intervention.id);
  });
  data = nmaDataToVizData(nmaData.interventions, selectedInterventions, config.interventionComparisonPairs, nmaData.comparisons, config.comparatorId, config.comparatorTableMode);
  outcomes = nmaData.outcomes.filter(function(outcome) {
    return config.selectedOutcomeIds.includes(outcome.id);
  });
  tableOrder = normalizeTableOrder(config.tableOrder, data, outcomes);
  return {
    props: {
      comparatorTableMode: config.comparatorTableMode,
      data: data,
      expandedRows: [],
      explanations: nmaData.explanations,
      outcomes: outcomes,
      showCoeInsufficientLabel: mediator.services.switches.isServerSwitchOn('acpFeatures'),
      tableOrder: tableOrder,
      transposed: Boolean(config.transposed),
      thresholdType: nmaData.thresholdType
    },
    settings: _.extend({}, config, {
      renderMode: 'printout',
      outcomes: outcomes,
      tableOrder: tableOrder,
      thresholdType: nmaData.thresholdType
    })
  };
};

module.exports = {
  buildNmaData: buildNmaData,
  buildNmaPrintoutTableData: buildNmaPrintoutTableData,
  getDefaultVizConfig: getDefaultVizConfig,
  getNmaQuestionOutcomes: getNmaQuestionOutcomes,
  normalizeTableOrder: normalizeTableOrder
};
